<template>
    <v-container>
        <v-row justify="space-around" no-gutters>
            <v-col cols="4" md="6">
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ $t('supplier') }}: </b> 
                        <br />
                        {{ invoice.supplier}}
                    </v-col>
                    <v-col cols="12" md="5">
                            <b>{{ $t('status') }}:</b> <br />
                            {{ documentStatusText() }}
                            <br />
                            <span v-if="invoice.rejectionNote && invoice.rejectionNote.length > 0"><b>{{ $t('reason') }}:</b> {{ invoice.rejectionNote }} </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-divider class="mt-5"></v-divider>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ invoiceNumberLabel }}: </b> <br />
                        {{ invoice.invoice}}
                        </v-col>
                    <v-col cols="12" md="5">
                        <b>{{ $t('deliveryDate') }}: </b> <br />
                        {{ invoice.deliveryDate }}
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ $t('contractNumber') }}: </b> <br />
                        {{ invoice.contractDocumentReference}}
                        </v-col>
                    <v-col cols="12" md="5">
                        <b>{{ $t('dueDate') }}:</b> <br />
                        {{ invoice.dueDate }}
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ $t('referenceNumber') }}: </b> <br />
                        {{ invoice.referenceNumber}}
                        </v-col>
                    <v-col cols="12" md="5">
                        <b>{{ $t('modelNum') }}:</b> <br />
                        {{ invoice.modelNumber }}
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ $t('amount') }}: </b> <br />
                        {{ formatNumberToString(invoice.amount) }} {{ invoice.currency }}
                        </v-col>
                    <v-col cols="12" md="5">
                        <span v-if="invoice.prepayments.length > 0"><b>{{ $t('prepayments') }}: </b> <br />
                        </span>
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" md="5">
                        <b>{{ billingReferenceLabel }} </b> <br />
                        {{ billingReferenceType }}
                        </v-col>
                    <v-col cols="12" md="5">
                        <span v-if="invoice.billingReferences.length > 0"><b>{{ $t('sourceInvoices')}}: </b>  <br />
                            <v-chip-group column>
                                <v-chip v-for="(reference, index) in invoice.billingReferences" :key="index" 
                                outlined
                                @click="openBillingReference(reference)">
                                    {{ reference.invoice }}
                                </v-chip>
                            </v-chip-group>
                        </span>
                        <span v-if="invoice.startDate"><b>{{ $t('period') }}:</b> <br />
                        {{ $t('from') }} {{ invoice.startDate }} {{ $t('to') }} {{ invoice.endDate }}
                        </span>
                    </v-col>
                </v-row> 
                <!--<v-row>
                    <v-divider class="mt-5"></v-divider>
                </v-row>
                <v-row>
                    <v-chip-group column>
                        <v-chip v-for="(file, index) in invoice.files" :key="index" 
                        outlined class="text-wrap"
                        @click="openFile(file)">
                            {{ file.name }}
                        </v-chip>
                    </v-chip-group>
                </v-row> --> 
            </v-col>
            <v-col cols="8" md="6">                
                <PDFViewer :source="pdfFile" :controls="c"  filename="" style="height: 200%; width: 100%" />
                <div>
                    <!--{{currentPage}} / {{pageCount}}
                    <pdf
                        src="pdfFile"
                        @num-pages="pageCount = $event"
                        @page-loaded="currentPage = $event"
                    ></pdf>-->
                    <!--<iframe :src="pdfFile" style="width: '100%', height: '100%'"  />-->
                    <!--<vue-pdf-embed :source="pdfFile" height />-->
                    <!--<vue-pdf-app :pdf="pdfFile" file-name="file name"></vue-pdf-app>-->
                </div>
            </v-col>
        </v-row>
        <v-row class="footer"
        no-gutters
        >
            <v-btn
            dark
            class="mx-2"
            color="#2b5d66"
            @click="getsignature">
            {{ $t('downloadSignature') }}
            </v-btn>
            <v-btn
            class="mx-2"
            dark
            color="#2b5d66"
            @click="download">
            {{ $t('download') }}
            </v-btn>
             <v-btn
            class="mx-2"
            dark
            color="#2b5d66"
            @click="downloadXML">
            {{ $t('downloadXML') }}
            </v-btn>
            <v-btn
            class="mx-2"
            dark
            color="#2b5d66"
            v-if="(seen || newInvoice || renotified || rejected) && userPermission('AcceptRejectPurchaseInvoice')"
            @click="approve()">
            {{ $t('accept') }}
            </v-btn>
            <v-btn
            class="mx-2"
            dark
            color="#2b5d66"
            v-if="(seen || newInvoice || renotified) && userPermission('AcceptRejectPurchaseInvoice')"
            @click="reject()">
            {{ $t('reject') }}
            </v-btn>
        </v-row>
        <RejectDialog :rejectInvoice="rejectInvoice" ref="rejectDialog" />
    </v-container>
</template>

<script>
    import RejectDialog from "../components/RejectDialog.vue"
    import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
    //import pdf from 'vue-pdf'
    //import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
    //import VuePdfApp from "vue-pdf-app";
    //import "vue-pdf-app/dist/icons/main.css";
    export default {
        name: "PurchaseInvoice",
        components: {
            RejectDialog,
            PDFViewer,
            //pdf
            //VuePdfEmbed
            //VuePdfApp
        },
        data() {
            return {
                n:null,
                s:{ defaultZoom: 50 },
                c:["rotate", "zoom", "switchPage", "catalog"],
                currentPage: 0,
                pageCount: 0,
                invoice: {
                    id: -1,
                    invoiceId: -1,
                    invoice: "",
                    statusId: -1,
                    docTypeId: -1,
                    status: "",
                    supplier: "",
                    contractDocumentReference: "",
                    amount: "",
                    currency: "",
                    modelNumber: "",
                    referenceNumber: "",
                    deliveryDate: "",
                    dueDate: "",
                    note: "",
                    startDate: "",
                    endDate: "",
                    rejectionNote: "",
                    billingReferences: [],
                    prepayments: [],
                    files: []
                },
                pdfFile: "",
                rejectInvoice: {
                    comment: ""
                },
            }
        },
        created() {
            this.invoiceData();
        },
        computed: {
            loggedUser() {
                return this.$store.getters.loggedUser;
            },
            newInvoice() {
                return this.invoice.statusId == 1
            },
            seen() {
                return this.invoice.statusId == 14
            },
            renotified() {
                return this.invoice.statusId == 16
            },
            rejected() {
                return this.invoice.statusId == 11
            },
            selectedOrganization() {
                return this.$store.getters.organizationId;
            },
            invoiceNumberLabel() {
                if(this.invoice.docTypeId == 1)
                    return this.$t('invoiceNum');
                if(this.invoice.docTypeId == 2)
                    return this.$t('creditNoteNum');
                if(this.invoice.docTypeId == 3)
                    return this.$t('debitNoteNum');
                if(this.invoice.docTypeId == 4)
                    return this.$t('prepaymentNum');
                return ""
            },
            billingReferenceLabel() {
                if(this.invoice.docTypeId== 2)
                    return this.$t('creditNoteRefersTo')
                if(this.invoice.docTypeId == 3)
                    return this.$t('debitNoteRefersTo')
                return ""
            },
            billingReferenceType() {
                if(this.invoice.billingReferences.length > 0)   
                    return this.$t('individualInvoice');
                if(this.invoice.startDate)
                    return this.$t('invoiceInPeriod');
                return "";
            }
        },
        methods: {
            invoiceData() {
                if(this.$route.query.id != undefined) {
                    this.axios.get('PurchaseInvoices/GetPurchasesInvoiceDetails?invoiceId=' + this.$route.query.id).then((response) => {
                        this.invoice = response.data
                        //this.pdfFile = this.invoice.files[0].path
                        this.pdfFile = 'data:application/pdf;base64,' + this.invoice.pdfFile
                        //this.pdfFile = 'C:/EfakturePurchaseOutput/2022-08-23/230048/Attachments_23082022125706.pdf'
                        /*const file = this.invoice.files[0].path
                        const reader = new FileReader()

                        let rawImg;
                        reader.onloadend = () => {
                        rawImg = reader.result;
                        console.log(rawImg);
                        }
                        reader.readAsDataURL(file);
                        console.log(file)*/
                    })
                    .catch(err => console.log(err));
                }
            },
            userPermission(action) {
                const isFound = this.loggedUser.permission.some(element =>{
                    if(element.permission === action)
                    return true;
                });
                return isFound;
            },
            openBillingReference(reference) {
                if(reference.id > 0) {
                    let route = this.$router.resolve({ name: 'PurchaseInvoice', query: {id: reference.id }})  
                    window.open(route.href);
                }
                else {
                    this.$root.displayNotificationMsg(this.$t('invoiceNotExistsMessage', {invoice: reference.invoice}), 'warning')
                }
            },
            formatNumberToString(value) {
                value = value.toString().replace(",", ".");
                var formatter = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2});
                return formatter.format(value);
            },
            openFile(file) {
                var formData = new FormData();
                formData.append('file', file);
                formData.append('path', JSON.stringify(file.path));

                this.axios.post('PurchaseInvoices/OpenAttachment', formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }, responseType: 'arraybuffer',
                    }).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                window.open(fileURL, '_blanck')
                }, (error) => {
                    console.log("Error: " + error);
                    console.log(error);
                })
            },
            getsignature() {
                this.axios({
                    url: 'PurchaseInvoices/GetPurchaseInvoiceSignature?id=' + this.invoice.id + '&invoiceId=' + this.invoice.invoiceId + '&organizationId=' + this.$store.getters.organizationId,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {  
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.invoice.invoice + '_sgn.zip');
                    document.body.appendChild(fileLink);
                    
                    fileLink.click();
                    })
                    .catch(err => console.log(err))
                },
            download() {
                this.axios({
                    url: 'PurchaseInvoices/GetPurchaseInvoicePDF?invoiceId=' + this.invoice.invoiceId,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {  
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    var contetnType = response.headers['content-type'];
            
                    fileLink.href = fileURL;
                    if(contetnType.includes('zip')){
                        fileLink.setAttribute('download',  this.invoice.invoice + '.zip');
                    }
                    else{
                        fileLink.setAttribute('download',  this.invoice.invoice + '.pdf');
                    } 
                    document.body.appendChild(fileLink);
                    
                    fileLink.click();
                    this.filterInvoices();
                }).catch(err => console.log(err))
            },
            downloadXML() {
                this.axios({
                    url: 'PurchaseInvoices/GetPurchaseInvoiceXML?invoiceId=' + this.invoice.invoiceId,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {  
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.invoice.invoice + '.xml');
                    document.body.appendChild(fileLink);
                    
                    fileLink.click();
                    })
                    .catch(err => console.log(err))
            },
            async approve() {
                if(await this.$confirm('Da li ste sigurni da želite da prihvatite fakturu ' + this.invoice.invoice + '?', { title: 'Upozorenje', buttonTrueText: 'Da', buttonFalseText: 'Ne', persistent: true })) {
                    var formData = new FormData()
                    formData.append('comment', JSON.stringify(''))
                    this.axios.post('PurchaseInvoices/PurchaseInvoiceAccepted?organizationId=' + this.selectedOrganization + '&id=' + this.invoice.id + '&invoiceId=' + this.invoice.invoiceId + '&accepted=true', formData)
                    .then((response) => {                       
                        if(response.status == 200){
                            this.invoice = response.data;
                            this.$root.displayNotificationMsg(this.$t('invoiceAccepted', {invoice: this.invoice.invoice}), 'success')
                        }
                    })
                    .catch((error) => { 
                        console.log("Error: " + error);
                        console.log(error.response.data);
                        this.$root.displayNotificationMsg(error.response.data, 'warning'); 
                    })
                }
            },
            async reject() {
                const confirmation = await this.$refs.rejectDialog.showDialog()
                if (confirmation === 'ok') {
                    var formData = new FormData()
                    formData.append('comment', JSON.stringify(this.rejectInvoice.comment))
                    this.axios.post('PurchaseInvoices/PurchaseInvoiceAccepted?organizationId=' + this.selectedOrganization + '&id=' + this.invoice.id + '&invoiceId=' + this.invoice.invoiceId + '&accepted=false', formData)
                    .then((response) => {                    
                        if(response.status == 200){
                            this.invoice = response.data;
                            this.$root.displayNotificationMsg(this.$t('invoiceRejected', {invoice: this.invoice.invoice}), 'success')
                        }
                    })
                    .catch((error) => { 
                        console.log("Error: " + error);
                        console.log(error.response.data);
                        this.$root.displayNotificationMsg(error.response.data, 'warning'); 
                    })
                }      
            },
            documentStatusText() {
                
                if(localStorage.getItem('language') === 'eng')
                    return this.invoice.statusEng;
                else
                    return this.invoice.status;
            },
        }
    }
</script>
<style scoped>
    .footer {
    position:absolute;
    bottom:0;
    width:100%;
    height:60px;
    }
</style>